<section class="tenure-history-container">
    <div class="header">
        <div class="panel-header">
            <div class="panel-title">{{type === 'history' ? 'Search History' : 'Tenure Info'}}</div>
            <div class="associate-subtitle">
                <span>SPIN ID: {{data['spinId']}}</span>
                <span class="subtitle-separator">|</span>
                <span>Name: {{(data['firstName'] + ' ' + data['lastName']) | camelCase}}</span>
            </div>
        </div>
        <button class="close-btn" (click)="closeBtnOnClick($event)"><i class="fa-solid fa-xmark"></i></button>
    </div>

    <div class="accordion-container">
        @if(isLoadingHistory){
        <app-loading-skeleton [count]="1" width="100%" height="100%" borderRadius="8px"></app-loading-skeleton>
        }
        @else if(tenureHistory.length){
        @if(type === 'history'){
        <mat-accordion multi [togglePosition]="'after'">
            @for(data of tenureHistory; track idx; let idx = $index){
            <mat-expansion-panel [expanded]="true">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <div class="icon-container">
                            <ng-container *ngComponentOutlet="iconToShow"></ng-container>
                        </div>
                        <div class="date-container">
                            <div class="date-primary">{{data['createdon'] | date:'MMM d, y' }}</div>
                            <div class="date-meta">{{data.details.length}} record(s)</div>
                        </div>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                @for(row of data.details; track idx1; let idx1 = $index){
                <div class="th-card">
                    <div class="th-field">
                        <span class="th-label">{{'Tenure Adjustment Done By' | camelCase}}</span>
                        <span class="th-value-bold">{{(row['updatedBy'] ?? '—') | camelCase: true}}</span>
                    </div>
                    <div class="th-two-col">
                        <div class="th-field">
                            <span class="th-label">{{'Based Tenure (in Months)' | camelCase}}</span>
                            <span class="th-value-bold">{{row['actualTenure'] ?? '—'}}</span>
                        </div>
                        <div class="th-field">
                            <span class="th-label">{{'Adjusted Tenure (in Months)' | camelCase}}</span>
                            <span class="th-value-bold">{{row['adjustedTenure'] ?? '—'}}</span>
                        </div>
                    </div>
                    <div class="th-field">
                        <span class="th-label">{{'Comments' | camelCase}}</span>
                        <span class="th-value-bold">{{(row['comments'] ?? '—') | camelCase}}</span>
                    </div>
                    @if(showAttachment){
                    <div class="th-field">
                        <span class="th-label">{{'Attachment(s)' | camelCase}}</span>
                        @if(!row['attachment'] || row['attachment'].length <= 0){ <span class="th-value-bold">N/A</span>
                            }@else{
                            <div class="th-attachments">
                                @for(file of row['attachment']; track idx2; let idx2 = $index){
                                <span class="th-attachment-link" (click)="downloadFile(file)" onkeypress="">
                                    <i class="fa-solid fa-link"></i> {{file['displayName'] | camelCase}}
                                </span>
                                }
                            </div>
                            }
                    </div>
                    }
                </div>
                }
            </mat-expansion-panel>
            }
        </mat-accordion>
        }@else{
        <div class="th-card">
            <div class="th-field">
                <span class="th-label">{{'Tenure Adjustment Done By' | camelCase}}</span>
                <span class="th-value-bold">{{latestHistory['updatedByName'] ?? '—'}} ({{latestHistory['updatedBy'] ?? '—'}})</span>
            </div>
            <div class="th-two-col">
                <div class="th-field">
                    <span class="th-label">{{'Based Tenure (in Months)' | camelCase}}</span>
                    <span class="th-value-bold">{{latestHistory['actualTenure'] ?? '—'}}</span>
                </div>
                <div class="th-field">
                    <span class="th-label">{{'Adjusted Tenure (in Months)' | camelCase}}</span>
                    <span class="th-value-bold">{{latestHistory['adjustedTenure'] ?? '—'}}</span>
                </div>
            </div>
        </div>
        }
        }
        @else {
        <div class="no-tenure-history">
            <span>No Tenure History </span>
        </div>
        }
    </div>
</section>